export const imageResizingUrl = (url: string): string => {
	return url.replace('cntmbr.com/', 'cntmbr.com/cdn-cgi/image/width=500/')
}
